<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-dark nav-bar-color">
      <b-navbar-brand href="https://www.denisemascarenhas.com.br/" style="width: 100px;">
        <img 
          :src="logoSite" 
          alt="mahalila" 
          style="margin: 10px 0px 20px 40px;width:100%;height:auto;object-fit:cover;object-position:50% 50%"
        />
      </b-navbar-brand>
      
      <div class="container">
        <div class="mx-5" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active mx-5">
              <router-link class="nav-link" to="/">Home</router-link>
            </li>
            <li class="nav-item active">
              <router-link class="nav-link" to="/terapeutas">Terapeutas</router-link>
            </li>
          </ul>
        </div>

      <b-navbar-nav class="ml-auto sign-in-btn">
          <b-nav-item-dropdown right v-if="isUserLoggedIn">
            <template #button-content>
              <em>{{ user.name }}</em>
            </template>
            
            <b-dropdown-item v-if="userRoles.includes('admin')" to="/admin">
              Dashboard de Administrador
            </b-dropdown-item>
            
            <b-dropdown-item v-else to="/profile">
              Perfil
            </b-dropdown-item>

            <b-dropdown-item @click="logoutAsync">
              Sair
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item right v-else to="/login">
              Entrar
          </b-nav-item>

        </b-navbar-nav>
        <!-- <button 
          class="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarSupportedContent" 
          aria-controls="navbarSupportedContent" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button> -->
      
      </div>

    </nav>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import logoSite from '../assets/images/logoSite.png'

export default ({
    name: 'NavBar',
    components: {

    },
    data() {
      return {
        logoSite
      }
    },
    computed: {
      ...mapState([
        'isUserLoggedIn',
        'user',
        'userRoles'
      ])
    },
    methods: {
      async logoutAsync() {
        await this.$store.dispatch('logoutUser');
      }
    }
});

</script>

<style scoped>

.nav-bar-color {
  background-color: #851838;
  color: #851838;
}

.sign-in-btn {
  margin-right: 40px;
}

</style>
